import { UIEvent, useState } from 'react'
import { css } from '@emotion/react'
import ProductList from '@src/components/product/list/ProductList'

const ProductListPage = () => {
	const [loadNext, setLoadNext] = useState(true)
	const handleScroll = (e: UIEvent<HTMLDivElement>) => {
		const target = e.target as HTMLDivElement
		const bottom = target.scrollHeight - target.scrollTop - 400 <= target.clientHeight
		if (bottom) {
			setLoadNext(true)
		}
	}
	return (
		<div css={pageStyle} onScroll={handleScroll}>
			<ProductList loadNext={loadNext} setLoadNext={setLoadNext} />
		</div>
	)
}

const pageStyle = css`
	overflow-y: scroll;
	height: 100%;
	width: 100%;
	overflow-x: hidden;
`
export default ProductListPage
